import { CheckedFieldValue } from '../types'

export const getErrorMessage = (
  value?: CheckedFieldValue,
): string | undefined => {
  return value && !value.isValid ? value.errorMessage : undefined
}
